<div [class.sidebar]="isDialog">
  <div class="dialog-actions">
    <button mat-icon-button [matMenuTriggerFor]="moreActionsMenu" aria-label="More actions">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #moreActionsMenu="matMenu">
      <button mat-menu-item (click)="delete(reportMaterialDelivery)" [disabled]="!editable">
        <mat-icon>delete</mat-icon>
        <span>Delete</span>
      </button>
    </mat-menu>

    @if (dialogOptions.closable) {
      <button [mat-dialog-close]="componentResult" mat-mini-fab aria-label="Close Sidebar">
        <mat-icon title="Close Sidebar">close</mat-icon>
      </button>
    }

    @if (initialized) {
      <button mat-mini-fab (click)="editing = !editing" [disabled]="!editable">
        <mat-icon>edit</mat-icon>
      </button>
    }
  </div>

  @if (initialized) {
    <form [formGroup]="inputForm">
      <div class="container">
        @if (annotationPreviewUrl) {
          <section class="header">
            <div class="annotation-preview">
              <img [src]="annotationPreviewUrl" alt="Annotation Preview" />
            </div>
          </section>
        }
        <!-- Bid Item section -->
        <section class="header">
          @if (reportMaterialDelivery.bid_item) {
            <div class="bid-item link" (click)="openBidItemSelector()">
              <div class="title">{{reportMaterialDelivery.bid_item?.item}}</div>
            </div>
          }
          @if (!reportMaterialDelivery.bid_item) {
            <div class="input-placeholder" (click)="openBidItemSelector()">
              <button mat-icon-button [disabled]="!editing" color="accent">
                <mat-icon>add</mat-icon>
              </button>Add bid item
            </div>
          }
        </section>
        <!-- /Bid Item section -->
        <nav mat-tab-nav-bar class="sub-nav">
          <a mat-tab-link active="active">Details</a>
          <a mat-tab-link>Discussion</a>
        </nav>
        <!-- Bid Item section -->
        @if (reportMaterialDelivery.bid_item) {
          <section>
            <div class="bid-item link" (click)="openBidItemSelector()">
              <div class="mat-body">{{reportMaterialDelivery.bid_item?.description}}</div>
              <div class="mat-caption">UOM: {{reportMaterialDelivery.bid_item?.uom}}</div>
            </div>
          </section>
        }
        <!-- /Bid Item section -->
        <!-- quantity section -->
        <section>
          <div class="mat-body-2 row">Quantity:</div>
          @if (!editing) {
            <div class="mat-body">{{reportMaterialDelivery.quantity}}</div>
          }
          @if (editing) {
            <mat-form-field>
              <input matInput type="number" autocomplete="off" formControlName="quantity" [errorStateMatcher]="matcher" />
              @if (inputForm.controls.quantity.hasError('required')) {
                <mat-error>
                  This field is <strong>required</strong>
                </mat-error>
              }
              @if (inputForm.controls.quantity.hasError('error')) {
                <mat-error>
                  {{inputForm.controls.quantity.errors.error}}
                </mat-error>
              }
            </mat-form-field>
          }
        </section>
        <!-- /quantity section -->
        <!-- comment section -->
        <section>
          <div class="mat-body-2 row">Comment:</div>
          @if (!editing) {
            <div class="mat-body">{{reportMaterialDelivery.comment}}</div>
          }
          @if (editing) {
            <mat-form-field>
              <textarea matInput formControlName="comment" [errorStateMatcher]="matcher">
              </textarea>
              @if (inputForm.controls.comment.hasError('required')) {
                <mat-error>
                  This field is <strong>required</strong>
                </mat-error>
              }
              @if (inputForm.controls.comment.hasError('error')) {
                <mat-error>
                  {{inputForm.controls.comment.errors.error}}
                </mat-error>
              }
            </mat-form-field>
          }
        </section>
        <!-- /comment section -->
        <!-- Annotations section -->
        <section>
          <div class="mat-body-2">Annotations:</div>
          <div class="preview-list">
            @for (ann of reportMaterialDelivery.annotations; track ann) {
              <div>
                <img [src]="ann.getThumbnail()" alt="" />
                @if (editing) {
                  <button mat-icon-button aria-label="Delete" title="Delete" class="hover-icon"
                    (click)="removeAnnot(ann)">
                    <mat-icon>delete</mat-icon>
                  </button>
                }
              </div>
            }
          </div>
        </section>
        <!-- /Annotations section -->
        <!-- Pictures section -->
        <section>
          <div class="mat-body-2">Pictures:</div>
          <div class="preview-list">
            @for (pic of reportMaterialDelivery.pictures; track pic) {
              <div>
                <img [src]="pic.getThumbnail()" class="link"
                  (click)="appSrv.openCarousel($event, reportMaterialDelivery.pictures, pic)" />
                @if (editing) {
                  <button mat-icon-button aria-label="Delete" title="Delete" class="hover-icon"
                    (click)="removePicture(pic)">
                    <mat-icon>delete</mat-icon>
                  </button>
                }
              </div>
            }
            <app-file-uploader class="input-placeholder small" [disabled]="!editing" icon="image" accept="image/*"
              (complete)="onUploadComplete($event)">
            </app-file-uploader>
          </div>
        </section>
        <!-- /Pictures section -->
        <!-- Tickets section -->
        <section>
          <div class="mat-body-2">Tickets:</div>
          <div class="preview-list">
            @for (ticket of reportMaterialDelivery.tickets; track ticket) {
              <div>
                <img [src]="ticket.getThumbnail()" class="link"
                  (click)="appSrv.openCarousel($event, reportMaterialDelivery.tickets, ticket)" />
                @if (editing) {
                  <button mat-icon-button aria-label="Delete" title="Delete" class="hover-icon"
                    (click)="removeTicket(ticket)">
                    <mat-icon>delete</mat-icon>
                  </button>
                }
              </div>
            }
            <app-file-uploader class="input-placeholder small" [disabled]="!editing" icon="attach_file"
              accept="application/pdf" (complete)="onTicketUploadComplete($event)">
            </app-file-uploader>
          </div>
        </section>
        <!-- /Tickets section -->
        <!-- Form Actions -->
        <section>
          @if (editing) {
            <div class="row">
              <button [disabled]="!editable" mat-stroked-button color="accent" (click)="saveItem()">
                @if (reportMaterialDelivery.id) {
                  Update
                }
                @if (!reportMaterialDelivery.id) {
                  Create
                }
              </button>
              <button mat-stroked-button (click)="onCancel()">Cancel</button>
            </div>
          }
        </section>
        <!-- Form Actions -->
      </div>
    </form>
  }

</div>
